"use strict";
export const version = "1.25.0";
//# sourceMappingURL=index.js.map
